export var FAVOURITE_1 = 1;
export var FAVOURITE_2 = 5;
export var FAVOURITE_3 = 10;
export var FAVOURITE_4 = 30;



// WEBPACK FOOTER //
// ./src/constants/FavoriteAmount.js